export type ExtraProps = Record<string, { value: string; type: 'text' | 'datetime' }>;

export function normalizeExtraProps(extraProps: ExtraProps, language: string) {
  const normalizedExtraProps: Record<string, string> = {};
  Object.entries(extraProps).forEach((element) => {
    const [key, { value, type }] = element;

    switch (type) {
      case 'datetime':
        normalizedExtraProps[key] = new Date(value).toLocaleString(language, {
          dateStyle: 'medium',
          timeStyle: 'short',
        });
        break;
      case 'text':
      default:
        normalizedExtraProps[key] = value;
        break;
    }
  });

  // required for shared files where we want to show title and filename
  // not the best solution, but ok for now.
  if (normalizedExtraProps.fileName && normalizedExtraProps.title) {
    normalizedExtraProps.fileName = `${normalizedExtraProps.title}/${normalizedExtraProps.fileName}`;
  }

  return normalizedExtraProps;
}
